import React from "react";
import styled, { css } from "styled-components";
import { ListGroup, ListGroupItem } from "components/bootstrap";
import ValueRenderer from "views/components/visualizations/OnClickPopover/ValueRenderer";
import { humanSeparator, multipleValuesActionsSupportedVisualizations } from "views/Constants";
const StyledListGroup = styled(ListGroup)`
  max-height: 300px;
  overflow-y: auto;
`;
const GroupingsContainer = styled.div(
  ({ theme, $withMargin }) => css`
    margin-left: ${$withMargin ? theme.spacings.sm : 0};
  `
);
const Label = styled.div(
  ({ theme }) => css`
    margin-bottom: ${theme.spacings.xxs};
    font-size: ${theme.fonts.size.small};
    font-weight: bold;
    color: ${theme.colors.text.secondary};
  `
);
const Group = ({
  group,
  keyPrefix,
  setFieldData
}) => {
  if (!(group == null ? void 0 : group.length)) return null;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, group.map(({ text, value, field, traceColor }) => /* @__PURE__ */ React.createElement(
    ListGroupItem,
    {
      onClick: () => setFieldData({ value, field, contexts: null }),
      key: `${keyPrefix}-${value}-${field}`
    },
    /* @__PURE__ */ React.createElement(ValueRenderer, { value: text, field, traceColor })
  )));
};
const GroupingActions = ({
  columnPivotValues,
  rowPivotValues,
  setFieldData,
  metricValue = void 0,
  combineOperator = void 0
}) => {
  var _a;
  const groupings = [...columnPivotValues, ...rowPivotValues];
  const valuePath = groupings.map(({ value, field }) => ({ [field]: value }));
  const displayValue = groupings.map(({ text }) => text).join(humanSeparator);
  return /* @__PURE__ */ React.createElement(
    ListGroupItem,
    {
      onClick: () => {
        var _a2, _b;
        return setFieldData({
          value: (_a2 = metricValue == null ? void 0 : metricValue.value) != null ? _a2 : "",
          field: (_b = metricValue == null ? void 0 : metricValue.field) != null ? _b : "",
          contexts: { valuePath, valuePathOperator: combineOperator }
        });
      }
    },
    /* @__PURE__ */ React.createElement(ValueRenderer, { field: "", value: displayValue, traceColor: (_a = metricValue == null ? void 0 : metricValue.traceColor) != null ? _a : null })
  );
};
const OnClickPopoverValueGroups = ({ metricValue, rowPivotValues, columnPivotValues, setFieldData, config }) => {
  var _a, _b;
  const showMultipleAction = ((_a = rowPivotValues.length) != null ? _a : 0) + ((_b = columnPivotValues.length) != null ? _b : 0) > 1 && multipleValuesActionsSupportedVisualizations.includes(config.visualization);
  return /* @__PURE__ */ React.createElement(StyledListGroup, null, metricValue && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Label, null, "Metric"), /* @__PURE__ */ React.createElement(Group, { group: [metricValue], keyPrefix: "metricValue", setFieldData })), !!(showMultipleAction || (rowPivotValues == null ? void 0 : rowPivotValues.length) || (columnPivotValues == null ? void 0 : columnPivotValues.length)) && /* @__PURE__ */ React.createElement(Label, null, "Groupings"), showMultipleAction && /* @__PURE__ */ React.createElement(
    GroupingActions,
    {
      columnPivotValues,
      rowPivotValues,
      setFieldData,
      metricValue,
      combineOperator: config.visualization === "network" ? "EDGE" : void 0
    }
  ), /* @__PURE__ */ React.createElement(GroupingsContainer, { $withMargin: showMultipleAction }, /* @__PURE__ */ React.createElement(Group, { group: rowPivotValues, keyPrefix: "rowPivotValues", setFieldData }), /* @__PURE__ */ React.createElement(Group, { group: columnPivotValues, keyPrefix: "columnPivotValues", setFieldData })));
};
export default OnClickPopoverValueGroups;
